module.exports = __webpack_public_path__ + "img/icons BFr_13.2e733546.png";